import React from "react";
import styled from "styled-components";

// Radio
const RadioWrap = ({ children, ...props }) => {
    let { gap, col, row, name, stateValue, onChange, checked, align } = props;

    return (
        <CustomRadioWrap gap={gap} col={col} row={row} align={align}>
            {React.Children.map(children, (child, idx) => React.cloneElement(child, { name, idx, stateValue, onChange, checked }))}
        </CustomRadioWrap>
    );
};

const CustomRadioWrap = styled.div`
    display: flex;
    justify-content: ${prop => prop.align === 'right' ? 'flex-end' : 'flex-start' };
    align-items: flex-start;
    width: 100%;
    gap: 15px;

    ${(props) => props.gap && `gap: ${props.gap}px;`}
    ${(props) => props.col && `flex-direction: column;`}
    ${(props) => props.row && `flex-direction: row;`}
`;

let CustomRadio = styled.label`
    font-size: 15px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    letter-spacing: 0.005em;
    line-height: 1.15em;

    span {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        background-color: #fff;
        border: 1px solid var(--gray-color);
        border-radius: 20px;
        aspect-ratio: 1/1;

        &:before {
            content: "";
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 12px;
            height: 12px;
            background-color: #fff;
            border-radius: 20px;
            aspect-ratio: 1/1;
        }
    }

    &:has(input:checked) span {
        &:before {
            background-color: var(--main-dark-color);
        }
    }

    input {
        display: none;
    }
`;

const Radio = ({ children, ...props }) => {
    let { disabled, name, id, value, idx, stateValue, onChange, isChecked } = props;

    id = id ? id : idx >= 0 ? `${name}_${idx}` : "";

    const onChangeHandler = (e) => {
        if (onChange) {
            onChange(e);
        } else {
            stateValue[1]({ ...stateValue[0], [name]: e.target.value });
        }
    };

    return (
        <>
            <CustomRadio htmlFor={id}>
                <span></span>
                <input type="radio" name={name} id={id} value={value} checked={isChecked ? (isChecked === true ? true : false) : stateValue[0][name] === value ? true : false} disabled={disabled} onChange={(e) => onChangeHandler(e)} />
                {children}
            </CustomRadio>
        </>
    );
};

export { RadioWrap, Radio };
